import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const FlagsContext = createContext({ flags: {}, loading: true, refresh: () => {} });

const DEFAULTS = {
    "cote-secrete": false,
    club: false,
    festival: false,
    guides: false,
    magazine: true,
    concierge: true,
    loger: true,
    agenda: true,
    balades: true,
    galerie: true,
    parcours: true,
    adresses: true,
    destinations: true,
    experiences: true,
};

export function FlagsProvider({ children }) {
    const [flags, setFlags] = useState(DEFAULTS);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(() => {
        setLoading(true);
        api.get("/settings/flags").then((r) => {
            setFlags({ ...DEFAULTS, ...(r.data?.flags || {}) });
        }).catch(() => {}).finally(() => setLoading(false));
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <FlagsContext.Provider value={{ flags, loading, refresh }}>
            {children}
        </FlagsContext.Provider>
    );
}

export const useFlags = () => useContext(FlagsContext);
